export class Swipers {
  constructor() {
  }

  static checkNavigationState(btnPrev, btnNext, navigationBlock) {
    if (!btnPrev || !btnNext || !navigationBlock) {
      return;
    }

    const isPrevDisabled = btnPrev.classList.contains('swiper-button-disabled');
    const isNextDisabled = btnNext.classList.contains('swiper-button-disabled');
    console.log(`navigationBlock:${navigationBlock}`);
    if (navigationBlock) {
      navigationBlock.classList.toggle(
        'is-disabled',
        isPrevDisabled && isNextDisabled);
    }
  }

  static changeSlideHover(elem) {
    if (elem) {
      elem.forEach((el) => el.addEventListener(
        'mouseover',
        () => {
          el.click();
        }));
    }
  }

  static initCatalog(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((slider) => {
        const sliderBtnPrev = slider.querySelector('[data-slider-brands="arrow-next"]');
        const sliderBtnNext = slider.querySelector('[data-slider-brands="arrow-prev"]');
        const navigationSlider = slider.querySelector('.swiper-navigation');
        new Swiper(
          slider,
          {
            spaceBetween: 10,
            slidesPerView: 1,
            effect: 'fade', // mousewheelControl: true,
            // mousewheel: {
            //   releaseOnEdges: true,
            // },
            pagination: {
              el: slider.querySelector('[data-slider-catalog="pagination"]'),
              clickable: true,
              bulletActiveClass: 'is-active',
              bulletClass: 'slider-pagination__btn',
              renderBullet(index, className) {
                return `<button class="${className}" type="button" aria-label="Перейти на ${index + 1} слайд"></button>`;
              },
            },
            on: {
              init: function () {
                const slideBulletBtn = slider.querySelectorAll('.slider-pagination__btn');
                Swipers.changeSlideHover(slideBulletBtn);
                Swipers.checkNavigationState(
                  sliderBtnPrev,
                  sliderBtnNext,
                  navigationSlider);
              },
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initIntro(node) {
    if (node) {
      const pagination = node.querySelector('[data-slider-intro="pagination"]');
      new Swiper(
        node,
        {
          spaceBetween: 0,
          slidesPerView: 1,
          effect: 'fade',
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: pagination,
            clickable: true,
            bulletActiveClass: 'is-active',
            bulletClass: 'intro__pagination-btn',
            renderBullet(index, className) {
              return `<button class="${className}" type="button" aria-label="Перейти на ${index + 1} слайд"></button>`;
            },
          },
        });
    }
  }

  static initBrands(nodes) {
    if (nodes) {
      const slider = nodes.querySelector('.swiper');
      const sliderBtnPrev = nodes.querySelector('[data-slider-brands="arrow-next"]');
      const sliderBtnNext = nodes.querySelector('[data-slider-brands="arrow-prev"]');
      const navigationSlider = nodes.querySelector('.swiper-navigation');

      new Swiper(
        slider,
        {
          spaceBetween: 10,
          slidesPerView: 2,
          grid: {
            rows: 3,
            fill: 'row',
          },
          navigation: {
            nextEl: sliderBtnPrev,
            prevEl: sliderBtnNext,
          },
          breakpoints: {
            768: {
              slidesPerView: 'auto',
              grid: false,
              spaceBetween: 40,
            },
          },
          on: {
            init: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            resize: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            update: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
          },
        });
    }
  }

  static initFive(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((sliderParent) => {
        const slider = sliderParent.querySelector('.swiper');
        const sliderBtnPrev = sliderParent.querySelector('[data-slider-goods="arrow-next"]');
        const sliderBtnNext = sliderParent.querySelector('[data-slider-goods="arrow-prev"]');
        const navigationSlider = sliderParent.querySelector('.swiper-navigation');

        new Swiper(
          slider,
          {
            spaceBetween: 0,
            slidesPerView: 2,
            navigation: {
              nextEl: sliderBtnPrev,
              prevEl: sliderBtnNext,
            },
            breakpoints: {
              768: {
                slidesPerView: 'auto',
              },
              1500: {
                slidesPerView: 5,
              },
            },
            on: {
              init: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initFour(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((sliderParent) => {
        const slider = sliderParent.querySelector('.swiper');
        const sliderBtnPrev = sliderParent.querySelector('[data-slider-goods="arrow-next"]');
        const sliderBtnNext = sliderParent.querySelector('[data-slider-goods="arrow-prev"]');
        const navigationSlider = sliderParent.querySelector('.swiper-navigation');
        new Swiper(
          slider,
          {
            spaceBetween: 0,
            slidesPerView: 2,
            navigation: {
              nextEl: sliderBtnPrev,
              prevEl: sliderBtnNext,
            },
            breakpoints: {
              900: {
                slidesPerView: 3,
              },
              1500: {
                slidesPerView: 4,
              },
            },
            on: {
              init: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initThree(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((sliderParent) => {
        const slider = sliderParent.querySelector('.swiper');
        const sliderBtnPrev = sliderParent.querySelector('[data-slider="arrow-next"]');
        const sliderBtnNext = sliderParent.querySelector('[data-slider="arrow-prev"]');
        const navigationSlider = sliderParent.querySelector('.swiper-navigation');
        new Swiper(
          slider,
          {
            spaceBetween: 20,
            slidesPerView: 1,
            grid: {
              rows: 2,
              fill: 'row',
            },
            navigation: {
              nextEl: sliderBtnPrev,
              prevEl: sliderBtnNext,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 40,
                grid: false,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 40,
                grid: false,
              },
            },
            on: {
              init: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initThreeCenter(nodes) {
    if (nodes) {
      const slider = nodes.querySelector('.swiper');
      const sliderBtnPrev = nodes.querySelector('[data-slider="arrow-next"]');
      const sliderBtnNext = nodes.querySelector('[data-slider="arrow-prev"]');
      const navigationSlider = nodes.querySelector('.swiper-navigation');
      new Swiper(
        slider,
        {
          spaceBetween: 20,
          slidesPerView: 1,
          grid: {
            rows: 2,
            fill: 'row',
          },
          navigation: {
            nextEl: sliderBtnPrev,
            prevEl: sliderBtnNext,
          },
          breakpoints: {
            768: {
              initialSlide: 1,
              centeredSlides: true,
              slidesPerView: 2.4,
              spaceBetween: 40,
              grid: false,
            },
          },
          on: {
            init: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            resize: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            update: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
          },
        });
    }
  }

  static initOnlyDesktop(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((sliderParent) => {
        const slider = sliderParent.querySelector('.swiper');
        const navigationSlider = sliderParent.querySelector('.swiper-navigation');
        const sliderBtnPrev = sliderParent.querySelector('[data-slider-desktop="arrow-next"]');
        const sliderBtnNext = sliderParent.querySelector('[data-slider-desktop="arrow-prev"]');

        new Swiper(
          slider,
          {
            spaceBetween: 50,
            slidesPerView: 3,
            navigation: {
              nextEl: sliderBtnPrev,
              prevEl: sliderBtnNext,
            },
            breakpoints: {
              1200: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1300: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1500: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            },
            on: {
              init: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initOnlyMobile(nodes) {
    if (nodes.length > 0) {
      nodes.forEach((sliderParent) => {
        const slider = sliderParent.querySelector('.swiper');
        const sliderBtnPrev = sliderParent.querySelector('[data-slider-mobile="arrow-next"]');
        const sliderBtnNext = sliderParent.querySelector('[data-slider-mobile="arrow-prev"]');
        const navigationSlider = sliderParent.querySelector('.swiper-navigation');
        new Swiper(
          slider,
          {
            spaceBetween: 10,
            slidesPerView: 2,
            navigation: {
              nextEl: sliderBtnPrev,
              prevEl: sliderBtnNext,
            },
            breakpoints: {
              720: {
                spaceBetween: 10,
                slidesPerView: 'auto',
              },
            },
            on: {
              init: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              resize: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
              update: () => Swipers.checkNavigationState(
                sliderBtnPrev,
                sliderBtnNext,
                navigationSlider),
            },
          });
      });
    }
  }

  static initMainBrands(nodes) {
    if (nodes) {
      const sliderPagination = nodes.querySelector('[data-main-brands="pagination"]');
      const sliderBtnPrev = nodes.querySelector('[data-slider="arrow-next"]');
      const sliderBtnNext = nodes.querySelector('[data-slider="arrow-prev"]');
      const navigationSlider = nodes.querySelector('.swiper-navigation');
      new Swiper(
        nodes,
        {
          spaceBetween: 10,
          slidesPerView: 'auto',
          pagination: {
            el: sliderPagination,
            clickable: true,
            bulletActiveClass: 'is-active',
            bulletClass: 'brands__inner-pagination-btn',
            renderBullet(index, className) {
              return `<button class="${className}" type="button" aria-label="Перейти на ${index + 1} слайд"></button>`;
            },
          },
          breakpoints: {
            768: {
              spaceBetween: 40,
            },
          },
          on: {
            init: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            resize: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
            update: () => Swipers.checkNavigationState(
              sliderBtnPrev,
              sliderBtnNext,
              navigationSlider),
          },
        });
    }
  }

  static initThumb(nodes) {
    if (nodes) {
      const sliderThumbMain = nodes.querySelector('[data-slider="slider-thumb-main"]');
      const sliderThumbPreview = nodes.querySelector('[data-slider="slider-thumb-preview"]');

      new Swiper(
        sliderThumbPreview,
        {
          loop: false,
          spaceBetween: 5,
          slidesPerView: 5,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideVisibleClass: 'is-visible',
          breakpoints: {
            1200: {
              spaceBetween: 15,
              direction: 'vertical',
            },
          },

        });

      new Swiper(
        sliderThumbMain,
        {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: nodes.querySelector('[data-slider="slider-thumb-nav-next"]'),
            prevEl: nodes.querySelector('[data-slider="slider-thumb-nav-prev"]'),
          },
          thumbs: {
            swiper: sliderThumbPreview,
          },
        });
    }
  }
}
